module.exports = __webpack_public_path__ + "tpay.png?b0ba650b8b1b9e6781bb646b1e3e9fab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/tpay.png
// module id = XYIP
// module chunks = 46